module.exports = __webpack_public_path__ + "static/gerb-25dc1ed2a564559795b5744717577a5a.svg";